import React from 'react';
import PropTypes from 'prop-types';
import { mapObject, constant, flatten, noop } from 'underscore';
import { Dropdown, DropdownMenuItemType } from '@fluentui/react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getContainerFactoryStyles } from './styles/categorized-dropdown-list-styles';

let dropdownStyles = {
  dropdownItemHeader: {
    color: 'black',
    fontWeight: 'bold',
  },
};

const ConstructOptionKey = (categoryKey, optionKey) => `${categoryKey}_${optionKey}`;

const DeConstructOptionKey = constructedOptionKey => ({
  categoryKey: constructedOptionKey.split('_')[0],
  optionKey: constructedOptionKey.split('_')[1],
});

const mapCatogriesToDropdownOptions = categories => flatten(categories.map((category, index) => {
  const options = category.value.map((item, innerIndex) => ({
    key: ConstructOptionKey(category.key, item.key ? item.key : innerIndex),
    text: item.text,
    title: item.text,
  }));
  // add header option
  options.unshift({ key: `${category.key}_Header`, text: category.text, itemType: DropdownMenuItemType.Header });
  // add divider option
  options.push({ key: `divider_${index}`, text: '-', itemType: DropdownMenuItemType.Divider });
  return options;
}));

const CategorizedDropdownListUnStyle = (props) => {
  const {
    classes: { CategorizedDropdownListContainer },
    categories,
    onSelectionChange,
    placeholder,
    label,
    dropdownStyle,
    selectedKey,
    forwardedRef,
    maxHeight,
    disabled,
  } = props;
  if (dropdownStyle) {
    const { title } = dropdownStyle;
    if (!title) {
      dropdownStyle.title = {
        borderColor: 'rgb(179, 176, 173)',
      };
    }
    if (title && !title.borderColor) {
      title.borderColor = 'rgb(179, 176, 173)';
    }
    dropdownStyles = { ...dropdownStyles, ...dropdownStyle };
  }

  const options = mapCatogriesToDropdownOptions(categories);
  const [selectedItem, setSelectedItem] = React.useState();
  let defaultSelectedKey;
  if (selectedKey) {
    const { categoryKey, optionKey } = selectedKey;
    defaultSelectedKey = ConstructOptionKey(categoryKey, optionKey);
  }

  const onChange = (_, item) => {
    setSelectedItem(item);
    const { categoryKey, optionKey } = DeConstructOptionKey(item.key);
    onSelectionChange({
      category: categoryKey,
      value: item,
      optionKey,
    });
  };

  return (
    <Dropdown
      componentRef={forwardedRef}
      label={label}
      selectedKey={selectedItem ? selectedItem.key : defaultSelectedKey}
      // eslint-disable-next-line react/jsx-no-bind
      onChange={onChange}
      placeholder={placeholder}
      options={options}
      className={CategorizedDropdownListContainer}
      styles={dropdownStyles}
      /**
       * this is a bug that if we set height or maxHeight on the callout , when we try to
       * scroll the callout it will jump up and down many times unexpectly.
       * so we have to use this workaround setting the maxHeight on the calloutMaxHeight
       *
       * seee details in https://github.com/microsoft/fluentui/issues/8748
       */
      calloutProps={maxHeight ? { calloutMaxHeight: maxHeight } : {}}
      disabled={disabled}
    />
  );
};

CategorizedDropdownListUnStyle.propTypes = {
  classes: PropTypes.shape(mapObject(
    getContainerFactoryStyles(),
    constant(PropTypes.string.isRequired)
  )).isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    value: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      text: PropTypes.string.isRequired,
    }).isRequired).isRequired,
  })).isRequired,
  onSelectionChange: PropTypes.func,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  dropdownStyle: PropTypes.object,
  selectedKey: PropTypes.shape({
    categoryKey: PropTypes.string.isRequired,
    optionKey: PropTypes.string.isRequired,
  }),
  // eslint-disable-next-line react/forbid-prop-types
  forwardedRef: PropTypes.any,
  maxHeight: PropTypes.string || PropTypes.number,
  disabled: PropTypes.bool,
};

CategorizedDropdownListUnStyle.defaultProps = {
  onSelectionChange: noop,
  placeholder: undefined,
  label: undefined,
  dropdownStyle: null,
  selectedKey: null,
  forwardedRef: null,
  maxHeight: null,
  disabled: false,
};

const CategorizedDropdownListStyled =
  withDefaultStyles(CategorizedDropdownListUnStyle, getContainerFactoryStyles);

export const CategorizedDropdownList =
  React.forwardRef((props, ref) => <CategorizedDropdownListStyled {...props} forwardedRef={ref} />);

